import React, { useEffect, useState } from "react";

import { getIsKeysOnlyMode } from "@lib/getIsKeysOnlyMode";

import { SESSION_STORAGE_KEYS } from "@shared/constants";

export const ShowKeys = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (getIsKeysOnlyMode()) {
      setIsActive(true);
    }
  }, []);

  const handleInputChange = () => {
    if (isActive) {
      sessionStorage.removeItem(SESSION_STORAGE_KEYS.SHOW_KEYS);
    } else {
      sessionStorage.setItem(SESSION_STORAGE_KEYS.SHOW_KEYS, "true");
    }
    window.location.reload();
  };

  return (
    <label className="text-xs flex items-center cursor-pointer select-none whitespace-nowrap">
      <input
        type="checkbox"
        checked={isActive}
        className="mr-1"
        onChange={handleInputChange}
      />
      <span>Show Translation Keys</span>
    </label>
  );
};
